/**
 * Manages all API endpoint URLs for the application
 */
export class UrlManager {
    // Employee related endpoints
    static getEmployeeUrl() {
        return '/get_employee';
    }
    static getEmployeeOverviewUrl() {
        return '/employee_overview';
    }
    static getUserDataUrl() {
        return '/user_data';
    }
    static getUserListtUrl() {
        return '/user_list';
    }
    static getRoleListtUrl() {
        return '/role_wise_users';
    }
    static getEmployeeTimeOffUrl() {
        return '/get_employee_time_off';
    }

    // Candidate related endpoints
    static getCandidateUrl() {
        return '/shortlisted_candidate_resume';
    }
    static getInterviewScheduledDataUrl() {
        return '/interview_scheduled_data';
    }
    static getCandidatePipelineUrl() {
        return '/candidate_pipeline';
    }

    // Notification
    static getNotificationUrl() {
        return '/get_notification';
    }
    static deleteNotificationUrl() {
        return `/delete_notification`;
    }

    // Content related endpoints
    static getTrendingTopicsUrl() {
        return '/trending_topic';
    }
    static getTipsOfTheDay() {
        return '/tips_of_the_day';
    }
    static getReviewRequestJd() {
        return '/review_request_jd';
    }
    static getApproveJd() {
        return '/approve_jd';
    }
    static getJobDescriptionsUrl() {
        return '/get_jd_requests';
    }
    static getGenerateJd() {
        return '/generate_jd';
    }
    static getReviewOfferLetter() {
        return '/review_offer_letter';
    }
    static getRegenerateOfferLetter() {
        return '/regenerate_offer_letter';
    }
    static getTodoList() {
        return '/get_todo_list';
    }
    static getPoliciesList() {
        return '/get_Policy_list';
    }
    static postTodoAction() {
        return '/todo';
    }

    static getEventsList() {
        return '/get_events';
    }

    // Job related endpoints
    static getJobRequestsUrl() {
        return '/get_job_requests';
    }
    static updateJobRequestStatus() {
        return '/update_job_request_status';
    }
    static getReviewApprovedJobRequestsUrl() {
        return '/review_approved_job_requests';
    }

    static getJobRequestDashboardUrl() {
        return '/job_request_dashboard';
    }
    static getReviewWfmJobRequestUrl() {
        return '/wfm_review_requisition';
    }

    // Chat and feedback endpoints
    static getChatUrl() {
        return '/chat';
    }
    static getChatFeedbackUrl() {
        return '/chat_feedback';
    }
    static getFeedbackUrl() {
        return '/feedback';
    }

    // Action and status endpoints
    static getActionRequestUrl() {
        return '/action_request';
    }
    static getSendOfferLetterUrl() {
        return '/send_offer_letters';
    }
    static getSendDirectorEmailUrl() {
        return '/send_director_email';
    }
    static getUpdateVideoStatusUrl() {
        return '/update_video_status';
    }

    // Review related endpoints
    static getReviewRequestUrl() {
        return '/review_request';
    }
    static getUpdateReviewStatusUrl() {
        return '/update_review_status';
    }

    // Widget
    static getWidgetsListUrl() {
        return '/get_widget_list';
    }
    static getWidgetsTempatesUrl() {
        return '/WidgetTemplates_list';
    }
    static updateRoleWidgetUrl() {
        return '/update_role';
    }
    static updateUserRoleUrl() {
        return '/update_user_role';
    }
}
